/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});



/**
 * Cake order functionalities
 */

// Toggle ingredients
let cakeingredients = document.getElementsByClassName('ingredients-wrapper');
if (cakeingredients !== null) {
  
  Array.from(cakeingredients).forEach(function(element, index, array) {
    element.addEventListener("click", function() { 
      this.getElementsByClassName("title")[0].classList.toggle('open');  
      this.getElementsByClassName("ingredients")[0].classList.toggle('open'); 
    });
  });
}

let cakeOrderForm = document.getElementsByClassName('order-cakes-form__wrapper');
if (cakeOrderForm !== null && cakeOrderForm.length > 0) {
  
  
     
  let i = 0;
  let maximum_cakes = 5;  // This should be set to same as how many product & person-price fields are added in GForm
  
  var cake_identifier = 1; // Used to determine how many cakes are placed in order.
 
  // Defaults, show add cake container.
  document.querySelectorAll('.add-cake-container')[0].style.display = 'block';
  
  while (i < maximum_cakes) {

    // By default hide all but first product and person & price fields. If they have value, show them.
    if (i > 0 && document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + i  + ' select')[0].value == '') {
      document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + i)[0].style.display = 'none';
      document.querySelectorAll('.order-cakes-form__wrapper .cake_size_and_price_' + i)[0].style.display = 'none';
      document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + i)[0].style.display = 'none';      
    }
    
    // Count how many cakes are already in order (use case: user presses submit and errors in form)
    if (document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + i)[0].style.display != 'none') {

      // Adjust remove button visibility
      if (cake_identifier > 1)
        document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + (cake_identifier - 1) + ' .remove-product')[0].style.display = 'none';

      cake_identifier++;      

      // Hide add new cake, if maximum amount of cakes
      if (cake_identifier == maximum_cakes) {
        document.querySelectorAll('.add-cake-container')[0].style.display = 'none';
      }
    }
    
    
    // Hide cake and price options first. Show correct choices depending what cake user selects
    let cake_price_and_description_select = document.querySelectorAll('.order-cakes-form__wrapper .cake_size_and_price_' + i + ' select');  
    let cake_price_and_description_options = document.querySelectorAll('.order-cakes-form__wrapper .cake_size_and_price_' + i + ' select option');
    
   
    let select_cake = document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + i + ' select');
    let selected_cake_value = '';
  
    // Set correct cake person/size and price options values to selectable.
    select_cake[0].addEventListener('change', function() {
      selected_cake_value = this.value.substring(0, this.value.indexOf('_'));

      // If cake chosen - don't hide cake person&price -value
      if (this.value == '')
        cake_price_and_description_select[0].value = '';
      
      cake_price_and_description_options.forEach(function (element, index, obj) {      
        // Set all options: default hidden
        if (index > 0) {
          element.setAttribute('hidden', true);
          element.setAttribute('visibility', 'hidden');
          element.setAttribute('disabled', 'disabled'); // Safari won't allow hide
        }
  
        if (element.getAttribute('value').substring(0, element.getAttribute('value').indexOf('_')) == selected_cake_value) {
          element.removeAttribute('hidden');
          element.removeAttribute('visibility');
          element.removeAttribute('disabled');  // Safari won't allow hide
        }
        
      });

     count_total_price(maximum_cakes); 
    });
    
    // Set values default, if already chosen some product (=cake) (ie. user submits form and there's errors, chosen values available).
    let changeEvent = new Event('change', {bubbles: true});
    document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + i + ' select')[0].dispatchEvent(changeEvent);
    
    
    // Set change events to fields, to count total order price when values change
    let select_cake_size_and_price = document.querySelectorAll('.order-cakes-form__wrapper .cake_size_and_price_' + i + ' select');
    let select_cakes_amount = document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + i + ' input');

    select_cake_size_and_price[0].addEventListener('change', function() { count_total_price(maximum_cakes); } );
    select_cake_size_and_price[0].dispatchEvent(changeEvent);
    
    select_cakes_amount[0].addEventListener('change', function() { count_total_price(maximum_cakes); } );    
    select_cakes_amount[0].dispatchEvent(changeEvent);
    
    i++;
  }
  
  

  /**
   * New cake to order
   *
   */
     
  document.getElementById('add-cake').addEventListener('click', function() {
        
    if (cake_identifier <= maximum_cakes) {
      
      // Adjust remove button visibility
      if (cake_identifier > 2 && cake_identifier <= maximum_cakes)
        document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + (cake_identifier - 2) + ' .remove-product')[0].style.display = 'none';

        document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + (cake_identifier - 1) + ' .remove-product')[0].style.display = 'block';      
      
      document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + (cake_identifier - 1))[0].style.display = 'block';
      document.querySelectorAll('.order-cakes-form__wrapper .cake_size_and_price_' + (cake_identifier - 1))[0].style.display = 'block';
      document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + (cake_identifier - 1))[0].style.display = 'block';      

      // Hide add new cake, if maximum amount of cakes
      if (cake_identifier == maximum_cakes)
        document.querySelectorAll('.add-cake-container')[0].style.display = 'none';

      cake_identifier++;
    }
    
    count_total_price(maximum_cakes);
  });
  // --end new cake to order
  
  /**
   * Remove cake from order
   */
  document.querySelectorAll('.remove-product').forEach(function (element, index, obj) {
    element.addEventListener('click', function() {
      
        let id = this.id.substring(12);
        
        // Adjust remove button visibility
        if (id > 1)
          document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + (id - 1) + ' .remove-product')[0].style.display = 'block';        
      
        document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + id)[0].style.display = 'none';
        document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + id + ' select')[0].value = '';
        let changeEvent = new Event('change', {bubbles: true});
        document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + id + ' select')[0].dispatchEvent(changeEvent);
        
        
        document.querySelectorAll('.order-cakes-form__wrapper .cake_size_and_price_' + id)[0].style.display = 'none';
        document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + id)[0].style.display = 'none';        
        cake_identifier--;
        
        // Show add new cake
        if (cake_identifier == maximum_cakes)
          document.querySelectorAll('.add-cake-container')[0].style.display = 'block';

        
        count_total_price(maximum_cakes);
    });
  });
  

  // User presses order cake button.
  let orderCakeBtn = document.querySelectorAll('.cakes-container .order-cake-btn');
  orderCakeBtn.forEach(function (element, index, obj) {
    element.addEventListener('click', function() {
      
      // Make change event triggerable.
      let changeEvent = new Event('change', {bubbles: true});      
      let tmpFirstCake = document.querySelectorAll('.order-cakes-form__wrapper .cake_name_0 select');
      
      if (cake_identifier == 2 && tmpFirstCake[0].value == '') {
        tmpFirstCake[0].value = this.getAttribute('data-cake-id');
        tmpFirstCake[0].dispatchEvent(changeEvent);
        
      } else {
        
        let addNewCake = new Event('click', {bubbles: true});
        document.getElementById('add-cake').dispatchEvent(addNewCake);
        
        let tmp_new_cake = document.querySelectorAll('.order-cakes-form__wrapper .cake_name_' + (cake_identifier - 2) + ' select');

        tmp_new_cake[0].value = this.getAttribute('data-cake-id');
        tmp_new_cake[0].dispatchEvent(changeEvent);
        
      }

    });
  });


  // Order total price, init
  let orderTotalPrice = document.querySelectorAll('.order-cakes-form__wrapper .order-total-price input');
  orderTotalPrice[0].setAttribute('readOnly', true);  
  count_total_price(maximum_cakes);  

}


function count_total_price(maxcakes) {
  let orderTotalPrice = document.querySelectorAll('.order-cakes-form__wrapper .order-total-price input');
  let totalPrice = 0;
  
  for (let j = 0; j < maxcakes; j++) {
    let parsedPrice = 0;
    let quantity = 0;
    
    parsedPrice = document.querySelectorAll('.order-cakes-form__wrapper .cake_size_and_price_' + j + ' select')[0].value;
    parsedPrice = parsedPrice.substring(parsedPrice.indexOf('-') + 1);
    parsedPrice = parsedPrice.replace('e', '');    
    quantity =  document.querySelectorAll('.order-cakes-form__wrapper .cake_quantity_' + j + ' input')[0].value;
    
    if (parsedPrice != '' && quantity != '')
      totalPrice = totalPrice + (parsedPrice * quantity);
    
  }

  orderTotalPrice[0].value = totalPrice + " €";
  
}
